// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3UGiG","image":"styles_image__3na43","code":"styles_code__3GT4X","btn":"styles_btn__2z7rB"};